'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadCatalogRegistration = exports.getAllUserCatalogRegistrationIds = exports.getUserCatalogRegistration = exports.LOAD_CATALOG_REGISTRATION_SUCCESS = exports.LOAD_CATALOG_REGISTRATION_REQUEST = exports.LOAD_CATALOG_REGISTRATION_FAIL = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _user = require('../modules/user');

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('../modules/config');

var _login = require('../modules/login');

var _registerForCatalog = require('../modules/registerForCatalog');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_REGISTRATION_FAIL = exports.LOAD_CATALOG_REGISTRATION_FAIL = 'la/domain/catalogRegistration/LOAD_FAIL';
var LOAD_CATALOG_REGISTRATION_REQUEST = exports.LOAD_CATALOG_REGISTRATION_REQUEST = 'la/domain/catalogRegistration/LOAD_REQUEST';
var LOAD_CATALOG_REGISTRATION_SUCCESS = exports.LOAD_CATALOG_REGISTRATION_SUCCESS = 'la/domain/catalogRegistration/LOAD_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    byId: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var catalogs = void 0;
    switch (action.type) {
        case _registerForCatalog.REGISTER_FOR_CATALOG_SUCCESS:
            return (0, _extends4.default)({}, state, {
                byId: (0, _extends4.default)({}, state.byId, (0, _defineProperty3.default)({}, action.payload, {
                    approved: false,
                    catalogId: action.payload,
                    pending: true,
                    registered: false
                }))
            });
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _login.LOGIN_SUCCESS:
            catalogs = {};
            if (action.payload.catalogRegistration) {
                action.payload.catalogRegistration.forEach(function (catalog) {
                    catalogs[catalog.catalogId] = catalog;
                });
            }
            return (0, _extends4.default)({}, state, {
                byId: catalogs
            });

        case LOAD_CATALOG_REGISTRATION_SUCCESS:
            catalogs = {};
            action.payload.forEach(function (catalog) {
                catalogs[catalog.catalogId] = catalog;
            });
            return (0, _extends4.default)({}, state, {
                byId: catalogs
            });

        case _user.LOG_OUT_BIDDER:
            return (0, _extends4.default)({}, DEFAULT_STATE);

        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.catalogRegistration;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var getUserCatalogRegistration = exports.getUserCatalogRegistration = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getAllUserCatalogRegistrationIds = exports.getAllUserCatalogRegistrationIds = function getAllUserCatalogRegistrationIds(state) {
    return (0, _keys2.default)(state.user.catalogRegistration.byId).map(function (catIdString) {
        return Number(catIdString);
    });
};

/* ACTION CREATORS */
var loadCatalogRegistrationFail = function loadCatalogRegistrationFail(error) {
    return {
        error: true,
        payload: error,
        type: LOAD_CATALOG_REGISTRATION_FAIL
    };
};

var loadCatalogRegistrationRequest = function loadCatalogRegistrationRequest() {
    return {
        type: LOAD_CATALOG_REGISTRATION_REQUEST
    };
};

var loadCatalogRegistrationSuccess = function loadCatalogRegistrationSuccess(registration) {
    return {
        payload: registration,
        type: LOAD_CATALOG_REGISTRATION_SUCCESS
    };
};

// Not used
var loadCatalogRegistration = exports.loadCatalogRegistration = function loadCatalogRegistration() {
    return function (dispatch, getState) {
        dispatch(loadCatalogRegistrationRequest());
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        return _api.Catalog.fetchRegisteredCatalogs({ authToken: authToken, deployment: deployment }).then(function (response) {
            dispatch(loadCatalogRegistrationSuccess(response.data));
        }).catch(function (error) {
            dispatch(loadCatalogRegistrationFail(error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogRegistration.js
// module id = uhYE
// module chunks = 46